import { render, staticRenderFns } from "./toCase.vue?vue&type=template&id=0573d49a&scoped=true&lang=pug"
import script from "./toCase.vue?vue&type=script&lang=js"
export * from "./toCase.vue?vue&type=script&lang=js"
import style0 from "./toCase.vue?vue&type=style&index=0&id=0573d49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573d49a",
  null
  
)

export default component.exports